import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import type { CreditsShoppingCartPricing } from '@/types/PricingCategory';
import { getUsDollarFormattedAmount } from '@/utils/utils';

interface Props {
  creditsPricingCategory: CreditsShoppingCartPricing[];
}
const InformationReturnsPricingDetails = (props: Props) => {
  return (
    <Box
      sx={{
        background: '#fff',
        borderRadius: 3,
        boxShadow: '0 0 20px rgba(0,0,0,.12)',
        p: 1.5,
        maxWidth: 836,
        mx: 'auto',
      }}
    >
      <TableContainer
        sx={{
          maxWidth: {
            xs: 'calc(100vw - 60px)',
            sm: 'calc(100vw - 25px)',
          },
          width: '100%',
          border: '1px solid rgba(224, 224, 224, 1)',
        }}
      >
        <Table
          sx={{
            minWidth: 50,
            '& td, & th': { p: 1, px: 2 },
          }}
          aria-label="Order History"
          className="table-list"
        >
          <TableHead
            sx={{
              borderBottomWidth: 2,
              borderBottomStyle: 'solid',
              borderBottomColor: '#9E9E9E',
              backgroundColor: '#f5f5f5',
            }}
          >
            <TableRow>
              <TableCell
                scope="row"
                align="left"
                sx={{ width: '100%', fontWeight: 600, fontSize: 15 }}
              >
                # W-2/1099 Forms
              </TableCell>
              <TableCell
                scope="row"
                align="left"
                sx={{
                  width: 150,
                  fontWeight: 600,
                  fontSize: 15,
                  whiteSpace: { sm: 'nowrap' },
                }}
              >
                Price Per Form
              </TableCell>
              <TableCell
                scope="row"
                align="right"
                sx={{ width: 100, fontWeight: 600, fontSize: 15 }}
              >
                Amount
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.creditsPricingCategory?.length > 0 ? (
              props.creditsPricingCategory.map((row, index) => (
                <TableRow key={index}>
                  <TableCell
                    style={{
                      fontWeight: 400,
                      fontSize: 13,
                    }}
                    align="left"
                  >
                    {row.FromCount} to {row.ToCount} (
                    <span style={{ fontWeight: 600 }}>{row.NoofForm}</span>)
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: 400,
                      fontSize: 13,
                      paddingLeft: 16,
                    }}
                    align="left"
                  >
                    {getUsDollarFormattedAmount(row.PerFormRate)}
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: 500,
                      fontSize: 13,
                      paddingLeft: 16,
                    }}
                    align="right"
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        color: '#14181F',
                        fontWeight: 600,
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {getUsDollarFormattedAmount(row.Amount)}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} sx={{ textAlign: 'center' }}>
                  Please enter the number of forms
                </TableCell>
              </TableRow>
            )}
            {/* <TableRow>
              <TableCell colSpan={2}>
                Total:
              </TableCell>
              <TableCell> {ConvertAmountFormat(totalAmount)}</TableCell>
            </TableRow> */}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
export default InformationReturnsPricingDetails;
